import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({ name: 'vbFormatDate',
	standalone: false
})
export class VbFormatDatePipe implements PipeTransform {
	public transform(date: any, format: string): string {
		return moment(date).format(format);
	}
}
